import { render, staticRenderFns } from "./AdditionalInformationChangesLog.vue?vue&type=template&id=496a1a7b&scoped=true"
import script from "./AdditionalInformationChangesLog.vue?vue&type=script&lang=js"
export * from "./AdditionalInformationChangesLog.vue?vue&type=script&lang=js"
import style0 from "./AdditionalInformationChangesLog.vue?vue&type=style&index=0&id=496a1a7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496a1a7b",
  null
  
)

export default component.exports